<template>
    <div v-if="show" aria-live="polite">
      <hp5-well-primary vertical-padding="md">
        <div id="alert-container">
          <hp5-icon name="system-info" size="lg" />
          <hp5-screen-reader-only>Information</hp5-screen-reader-only>
          <div id="alert-info">
            <hp5-heading tag-selection="h2"> Emergency care at any hospital emergency room is covered at in-network levels </hp5-heading>
            <hp5-semantic>
              <span>If you need follow-up care after an emergency, use </span>
              <span v-if="isAuthenticated"><a href="/fcp/landing-page/">in-network providers</a></span>
              <span v-else>in-network providers</span>
              <span> to make sure you’re covered. </span>
              <span v-if="!isAuthenticated"
                >Already a HealthPartners member? <a href="/public/login/?referrer=%2Ffcp%2Fcsearch">Sign in</a> to see in-network coverage.</span
              >
              <span>Not sure what care you need? Call a CareLine℠ nurse at </span>
              <span><a href="tel:800-551-0859">800-551-0859</a> for help, or visit our </span>
              <span><a href="https://www.healthwise.net/healthpartners/sxchecker/index">symptom checker</a>.</span>
            </hp5-semantic>
          </div>
        </div>
      </hp5-well-primary>
      <hp5-spacing-vertical xs="lg" sm="lg" md="lg" lg="lg"></hp5-spacing-vertical>
    </div>
</template>
  
<script setup>
      const { context, isAuthenticated, searchResults, hasSearched } = useFCPModel()
      const isHospital = computed(() => context.value.type == 'hospital:1')
      const show = computed(() => hasSearched.value && isHospital.value && searchResults.value && searchResults.value == 0)
</script>
  
<style scoped lang="scss">
  hp5-icon {
    fill: var(--color-info-base);
    position: relative;
    top: -6px;
  }
  
  #alert-container {
    display: flex;
  }
  
  #alert-info {
    padding-left: 30px;
  }
  </style>